/**
* Created by cc 19-10-25
* 抖音渠道左侧模块
*/
angular.module('editQiehaoLeftModule', [])
    .controller('EditQiehaoLeftCtrl', ['$scope', 'trsHttpService', '$location', '$state', '$timeout', '$element', '$q', 'editingMediatype',
        function($scope, trsHttpService, $location, $state, $timeout, $element, $q, editingMediatype){
            initStatus();
            initData();

            /**
			 * [initStatus description]初始化状态
			 *
			 * @return  {[type]}  [return description]
			 */
            function initStatus(){
                $scope.router = $location.path().split('/');
                $scope.status = {
                    platForm: 'waitcompiled',
                    params: {
                        // 'serviceid': 'mlf_kuaibaoaccount',
                        // 'methodname': 'queryAccounts',
                        // // "qieHaoAccountName": "",
                        // 'PageSize': 100,
                        // 'CurrPage': 1
                        MediaType: editingMediatype.qiehao,
                        PAGESIZE: 1000,
                        methodname: 'queryWebSitesByMediaType',
                        serviceid: 'mlf_mediasite',
                    },
                    isdownPicShow: false,
                    selectedChnlId: $state.params.account
                };
            }

            /**
			 * [initStatus description]初始化状态
			 *
			 * @return  {[type]}  [return description]
			 */
            function initData(){
                $scope.data = {
                    items: [],
                    selected: {},
                };
            }
			
            /**
			 * [requestData description]请求数据
			 *
			 * @return  {[type]}  [return description]
			 */
            function requestData() {
                var deffer = $q.defer();
                if ($scope.data.items && $scope.data.items.length !== 0) {
                    deffer.resolve();
                    return deffer.promise;
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function(data) {
                    !!data.DATA ? $scope.data.items = data.DATA : $scope.data.items = data;
                    if (!$scope.data.items.length) {return;}
                    var account = $scope.$parent.qiehaoid;
                    var items = $scope.data.items;
                    if (account) {
                        for (var i = 0; i < items.length; i++) {
                            if (account === items[i].KUAIBAOACCOUNTID) {
                                $scope.data.selected = items[i];
                                break;
                            }
                        }
                    } else {
                        $scope.data.selected = data.DATA[0];
                    }
                    $scope.status.selectedChnlId = $scope.data.selected.KUAIBAOACCOUNTID;
                    deffer.resolve();
                });
                return deffer.promise;
            }

            /**
			 * [autoLocation description]自动定位
			 *
			 * @param   {[type]}  platform  [platform description]
			 *
			 * @return  {[type]}            [return description]
			 */
            $scope.autoLocation = function(platform) {
                requestData().then(function() {
                    $timeout(function() {
                        var routerArray = $state.current.name.split('.');
                        if (routerArray.length === 3 || routerArray.length === 4) {
                            if ($scope.status.selectedChnlId !== undefined) {
                                $scope.switchChannel(platform, $scope.data.selected);
                            } else {
                                $element.find('a')[0].click();
                            }
                        }
                        // getWeiBoAccessAuthority();
                    });
                });
            };
            // 选择抖音渠道的栏目
            $scope.switchChannel = function(platform, channel) {
                var routerName = 'front.editctr.qiehao.' + platform;
                $scope.data.selected = channel;
                if (platform === 'waitcompiled' && channel.IS_ORIGINAL == '1') {
                    $state.go(routerName, { account: channel.KUAIBAOACCOUNTID, isOriginal: channel.IS_ORIGINAL, channelid: channel.CHANNELID }, { reload: routerName });
                } else {
                    $state.go(routerName, { account: channel.KUAIBAOACCOUNTID, channelid: channel.CHANNELID }, { reload: routerName });
                }
                $scope.status.selectedChnlId = channel.KUAIBAOACCOUNTID;
                $scope.status.selectRecycle = false;
                // getWeiBoAccessAuthority();
            };
            $scope.toRecycle = function(platform) {
                // if(!$scope.status.selectedChnlId) return;
                $scope.status.selectRecycle = platform;
                var routerName = 'front.editctr.qiehao.' + platform;
                $state.go(routerName, { account: $state.params.account, channelid: $state.params.channelid }, { reload: routerName });
                $scope.status.selectedChnlId = '';
            };

            /**
         * [headPicload description] 头像未能正常显示时显示默认头像
         * @param  {[object]} item [description] 微博账号对象
         * @return {[type]}      [description]
         */
            $scope.headPicload = function(item) {
                var imgObj = new Image();
                imgObj.src = item.HEADPIC;
                imgObj.onload = function() {
                    item.picUrl = item.HEADPIC;
                };
                imgObj.onerror = function() {
                    item.picUrl = './images/user_icon.jpg';
                };
            };
        }]);
